import { CronoButton } from "components/CronoButton";
import { useConditionalSnackBar } from "context/snackbar";
import useSyncDocuments from "hooks/services/documents/useSyncDocuments";
import useSyncQaAnswers from "hooks/services/documents/useSyncQaAnswers";
import { FC } from "react";
import { GeneralWrapper } from "../styles";

const CoreAI: FC = () => {
  const {
    isError: isSyncDocumentsError,
    isSuccess: isSyncDocumentsSuccess,
    isLoading: isSyncDocumentsLoading,
    mutate: syncDocuments,
  } = useSyncDocuments();

  const {
    isError: isSyncQaAnswersError,
    isSuccess: isSyncQaAnswersSuccess,
    isLoading: isSyncQaAnswersLoading,
    mutate: syncQaAnswers,
  } = useSyncQaAnswers();

  useConditionalSnackBar([
    {
      condition: !!isSyncDocumentsError,
      message: "Error during knowledge base sync",
      severity: "error",
    },
    {
      condition: !!isSyncDocumentsSuccess,
      message: "Knowledge base synced successfully",
      severity: "success",
    },
    {
      condition: !!isSyncQaAnswersError,
      message: "Error during QA answers sync",
      severity: "error",
    },
    {
      condition: !!isSyncQaAnswersSuccess,
      message: "QA answers synced successfully",
      severity: "success",
    },
  ]);

  return (
    <GeneralWrapper>
      <div className="user-form">
        <div className="form-control">
          <label>Sync the knowledge base documents to Core AI.</label>
          <CronoButton
            variant="contained"
            color="primary"
            className="mail-button"
            onClick={() => syncDocuments()}
            disabled={isSyncDocumentsLoading}
          >
            {isSyncDocumentsLoading ? "Syncing..." : "Sync Knowledge Base"}
          </CronoButton>
        </div>

        <div className="form-control">
          <label>Sync the QA answers to Core AI.</label>
          <CronoButton
            variant="contained"
            color="primary"
            className="mail-button"
            onClick={() => syncQaAnswers()}
            disabled={isSyncQaAnswersLoading}
          >
            {isSyncQaAnswersLoading ? "Syncing..." : "Sync QA Answers"}
          </CronoButton>
        </div>
      </div>
    </GeneralWrapper>
  );
};

export default CoreAI;
